export default __webpack_public_path__ + "static/media/640_dummy2016-anwaltskanzlei01-mobile-de.ee876a6d.png";